function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import QueryString from 'qs';
import { api } from './configs/axiosConfig';
import { NOTIFICATION_TITLES } from '@/utils/notificationUtils';
import { arrayBufferToBase64 } from '@/utils/utilities';
export var NotificationAPI = {
    getNotificationBundle: function getNotificationBundle(userId) {
        var _arguments = arguments;
        return _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var offset, limit, channels, platformHost, to, sixMonthsAgo, created, queryParams, response;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            offset = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 0;
                            limit = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : 100;
                            channels = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : ['pull'];
                            platformHost = _arguments.length > 4 && _arguments[4] !== undefined ? _arguments[4] : '';
                            to = userId; // Calculate date from 6 months ago with ge (greater than or equal) filter
                            sixMonthsAgo = new Date();
                            sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
                            created = "ge".concat(sixMonthsAgo.toISOString());
                            queryParams = {
                                limit: limit,
                                offset: offset,
                                to: to,
                                channels: channels,
                                created: created
                            };
                            _context.n = 1;
                            return api.get('/Notifications/', {
                                baseURL: platformHost,
                                params: queryParams,
                                paramsSerializer: function paramsSerializer(params) {
                                    return QueryString.stringify(params, {
                                        arrayFormat: 'repeat',
                                        encode: false
                                    });
                                }
                            });
                        case 1:
                            response = _context.v;
                            return _context.a(2, response.data);
                    }
            }, _callee);
        }))();
    },
    markNotificationAsRead: function markNotificationAsRead(messagesIdList, expires) {
        var _arguments2 = arguments;
        return _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            var platformHost, requestBody, response;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            platformHost = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : '';
                            requestBody = {
                                notification: messagesIdList.map(function (id) {
                                    var notification = {
                                        id: id,
                                        viewedDateTime: new Date().toISOString()
                                    };
                                    if (expires !== undefined) {
                                        notification.expires = expires;
                                    }
                                    return notification;
                                })
                            };
                            _context2.n = 1;
                            return api.patch('/Notifications/', requestBody, {
                                baseURL: platformHost
                            });
                        case 1:
                            response = _context2.v;
                            return _context2.a(2, response.data);
                    }
            }, _callee2);
        }))();
    },
    syncSubscription: function syncSubscription(subscription, subscriptionStatus, userId) {
        var _arguments3 = arguments;
        return _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var platformHost, keys, subscriptionData, response;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            platformHost = _arguments3.length > 3 && _arguments3[3] !== undefined ? _arguments3[3] : '';
                            keys = subscription.getKey ? {
                                p256dh: subscription.getKey('p256dh'),
                                auth: subscription.getKey('auth')
                            } : null;
                            subscriptionData = {
                                endpoint_details: [{
                                        endpoint: subscription.endpoint,
                                        keys: keys ? {
                                            p256dh: arrayBufferToBase64(keys.p256dh),
                                            auth: arrayBufferToBase64(keys.auth)
                                        } : null
                                    }],
                                is_subscribed: subscriptionStatus,
                                user_id: userId
                            };
                            _context3.n = 1;
                            return api.post('/Notifications/subscribe', subscriptionData, {
                                baseURL: platformHost
                            });
                        case 1:
                            response = _context3.v;
                            return _context3.a(2, response.data);
                    }
            }, _callee3);
        }))();
    },
    submitSurveyResponse: function submitSurveyResponse(ratingValue, user) {
        var _arguments4 = arguments;
        return _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            var platformHost, requestBody, response;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            platformHost = _arguments4.length > 2 && _arguments4[2] !== undefined ? _arguments4[2] : '';
                            requestBody = {
                                resourceType: 'SurveyResponse',
                                status: 'completed',
                                authored: new Date().toISOString(),
                                isResponseEditable: false,
                                subject: {
                                    userId: user === null || user === void 0 ? void 0 : user.id,
                                    userName: user === null || user === void 0 ? void 0 : user.name,
                                    userEmail: user === null || user === void 0 ? void 0 : user.email
                                },
                                informationSource: {
                                    userId: user === null || user === void 0 ? void 0 : user.id,
                                    userName: user === null || user === void 0 ? void 0 : user.name,
                                    userEmail: user === null || user === void 0 ? void 0 : user.email
                                },
                                item: [{
                                        linkId: 'NPS',
                                        text: NOTIFICATION_TITLES.FEEDBACK,
                                        answer: [{
                                                valueInteger: ratingValue
                                            }]
                                    }],
                                meta: {
                                    deviceId: '',
                                    clientRequestId: '',
                                    source: ''
                                }
                            };
                            _context4.n = 1;
                            return api.post('/SurveyResponse/', requestBody, {
                                baseURL: platformHost
                            });
                        case 1:
                            response = _context4.v;
                            return _context4.a(2, response.data);
                    }
            }, _callee4);
        }))();
    },
    /**
     * Get the user's last survey response to check when they last filled a survey
     * @param userId - The user ID to check
     * @returns Promise with the last survey response data or null if none exists
     */
    getLastSurveyResponse: function getLastSurveyResponse(userId) {
        var _arguments5 = arguments;
        return _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var platformHost, _response$data, _entries$, response, entries, _t;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.p = _context5.n) {
                        case 0:
                            platformHost = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : '';
                            _context5.p = 1;
                            _context5.n = 2;
                            return api.get('/SurveyResponse/', {
                                baseURL: platformHost,
                                params: {
                                    informationSource: userId,
                                    limit: 1,
                                    _sort: '-lastUpdated' // Sort by lastUpdated date descending to get the latest
                                }
                            });
                        case 2:
                            response = _context5.v;
                            entries = ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.entry) || [];
                            if (!(entries.length > 0 && (_entries$ = entries[0]) !== null && _entries$ !== void 0 && (_entries$ = _entries$.resource) !== null && _entries$ !== void 0 && (_entries$ = _entries$.meta) !== null && _entries$ !== void 0 && _entries$.lastUpdated)) {
                                _context5.n = 3;
                                break;
                            }
                            return _context5.a(2, {
                                lastUpdated: entries[0].resource.meta.lastUpdated
                            });
                        case 3:
                            return _context5.a(2, {
                                lastUpdated: null
                            });
                        case 4:
                            _context5.p = 4;
                            _t = _context5.v;
                            console.error('Error fetching last survey response:', _t);
                            return _context5.a(2, {
                                lastUpdated: null
                            });
                    }
            }, _callee5, null, [[1, 4]]);
        }))();
    }
};
